module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 448
// module chunks = 0